// eslint-disable-next-line jira/filename-case, jira/restricted/react-component-props
import React, { type ComponentType, type ComponentProps } from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { NudgeBundledUsersXflow } from './ui/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const NudgeBundledUsersFlagContainer = lazyForPaint<
	ComponentType<
		JSX.LibraryManagedAttributes<
			typeof NudgeBundledUsersXflow,
			ComponentProps<typeof NudgeBundledUsersXflow>
		>
	>
>(
	() =>
		import(/* webpackChunkName: "async-nudge-bundled-users-flag" */ './ui/index.tsx').then(
			(module) => module.NudgeBundledUsersXflow,
		),
	{ ssr: false },
);

export const AsyncNudgeBundledUsersFlagContainer = (): React.JSX.Element => (
	<JSErrorBoundary
		id="nudgeBundledUserFlag"
		packageName="nudgeBundledUsersToJoinConnie"
		fallback="unmount"
		teamName="confluenceOnboarding"
	>
		<UFOSegment name="nudge-bundled-users-flag">
			<Placeholder name="nudge-bundled-users-flag" fallback={null}>
				<NudgeBundledUsersFlagContainer />
			</Placeholder>
		</UFOSegment>
	</JSErrorBoundary>
);
